export abstract class CommunicatorNativeRemoteConfig {
    abstract getRemoteConfigCommunicator<T>(): Promise<T>
}